import React from 'react';

import s from './SubscriptionCenter.scss';

export interface Props {
  moduleId: number;
}

const SubscriptionCenter: React.FC<Props> = props => {
  return <div className={s['root']}>Center</div>;
};
SubscriptionCenter.displayName = 'SubscriptionCenter';

export default SubscriptionCenter;
